import React, { useMemo, useRef, memo } from "react";
import { BodyWrapper } from "../styles/components/body";
import BodyContentComponent from "./bodyContent";
import BodyHeadlineComponent from "./bodyHeadline";
import BodySliderComponent from "./bodySlider";

const BodyComponent = props => {
  const wrapperRef = useRef(null);

  const { articleData, ...rest } = props;
  const componentContent = useMemo(() => {
    return Object.values(rest).map(component => ({
      key: component.moduleTitle ? component.moduleTitle : component.key,
      content: component,
    }));
  }, [rest]);

  const bodyContentComponent = componentContent.find(
    c => c.key === "component--body-content"
  );
  const bodyItems = bodyContentComponent?.content?.content ?? [];

  const bodyHeadlineComponent = componentContent.find(
    c => c.key === "component--body-headline"
  );

  const bodyHeadlineItems = bodyHeadlineComponent?.content?.content ?? [];

  const bodySliderComponent = componentContent.find(
    c => c.key === "component--body-slider"
  );

  const bodySliderItems = bodySliderComponent?.content?.content ?? [];

  return (
    <BodyWrapper ref={wrapperRef}>
      {bodyItems && (
        <BodyContentComponent
          articleData={articleData}
          bodyItems={bodyItems}
          parentWrapperRef={wrapperRef}
        />
      )}
      {bodyHeadlineItems && (
        <BodyHeadlineComponent
          articleData={articleData}
          bodyItems={bodyHeadlineItems}
        />
      )}
      {bodySliderItems && (
        <BodySliderComponent
          articleData={articleData}
          bodyItems={bodySliderItems}
        />
      )}
    </BodyWrapper>
  );
};

export default memo(BodyComponent);
